/**
 * The files the conversation on screen has presented, as a React hook.
 *
 * Read from the delivery receipts in the session's loaded event window (`harness/orik-client.ts`), which is
 * the window the harness panel renders: the `present` tool's view reads it for each file's durable download.
 */
import { useMemo, useSyncExternalStore } from "react";
import type { OrikDelivery, OrikDshBridge } from "../../../harness/orik-client";

const NONE: readonly OrikDelivery[] = [];
const EMPTY = { getSnapshot: () => NONE, subscribe: () => () => {} };

/** The deliveries of one conversation, oldest first; empty until its session is open. */
export function useSessionDeliveries(sessionId: string | undefined): readonly OrikDelivery[] {
  const source = useMemo(() => {
    const bridge = (globalThis as { __ORIK_DSH__?: OrikDshBridge }).__ORIK_DSH__;
    return sessionId === undefined || bridge === undefined ? EMPTY : bridge.deliveries(sessionId);
  }, [sessionId]);
  return useSyncExternalStore(source.subscribe, source.getSnapshot, () => NONE);
}
